export default __webpack_public_path__ + "static/home-furnace-colling-hvac-minnesota-50143b9e71f8eda3f85677f1df3769f9.jpg";